<template>
  <v-dialog
    v-model="show"
    @click:outside="closeDialog()"
    content-class="dialogMedia"
  >
    <span class="titleAudio"
      >Audio {{ call.phone }} - {{ formatDate(call.callTime) }}</span
    >
    <IconClose class="close" @click="closeDialog()"></IconClose>
    <div class="contTagSelect">
      <div class="d-flex justify-space-between">
        <div>
          <v-icon>mdi-tag-outline</v-icon>
          <span class="text-body-2 font-weight-bold mx-2">Etiquetas</span>
        </div>
        <v-select
          class="customInpuntMedia"
          placeholder="Seleccionar"
          v-model="selectNewTag"
          @input="setNewTag()"
          item-value="Tag"
          :items="tagComments"
          :item-text="items"
          solo
        ></v-select>
      </div>
      <div class="contPrefix" v-if="!showAll">
        <div
          class="prefix"
          v-for="(item, index) in tagLimit"
          :key="index + '-tag-' + item"
        >
          <span class="textPrefix">{{ item }}</span>
          <v-btn icon small color="transparent" @click="removeTag(item)">
            <v-icon color="#2e2e2d">mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
        <div @click="showAll = true" v-if="call.tags.length > 4">
          <span class="textMore">mas...</span>
        </div>
      </div>
      <div class="contPrefix" v-if="showAll">
        <div
          class="prefix"
          v-for="(item, index) in call.tags"
          :key="index + '-tag-all-' + item"
        >
          <span class="textPrefix">{{ item }}</span>
          <v-btn icon small color="transparent" @click="removeTag(item)">
            <v-icon color="#2e2e2d">mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-show="!loading" class="contTime">
      <span class="textTime">00:00:00</span>
      <span class="textTime">{{ time2 }}</span>
      <span class="textTime">{{ time3 }}</span>
      <span class="textTime">{{ timeF }}</span>
    </div>
    <div class="contWavesurfer">
      <div v-show="!loading" id="wave"></div>
      <div class="contVol" v-show="!loading">
        <div class="vol">
          <IconMute v-if="volL == 0" @click="volL = 10"></IconMute>
          <IconSound v-else @click="volL = 0"></IconSound>
          <div id="volControl1" class="volControl">
            <v-slider v-model="volL" max="10" min="0"></v-slider>
          </div>
        </div>
        <div class="vol">
          <IconMute v-if="volR == 0" @click="volR = 10"></IconMute>
          <IconSound v-else @click="volR = 0"></IconSound>
          <div id="volControl1" class="volControl">
            <v-slider v-model="volR" max="10" min="0"></v-slider>
          </div>
        </div>
      </div>
    </div>
    <div v-show="loading" class="contLoading">
      <v-progress-circular
        v-show="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <div class="contFooter">
      <div class="contRelative">
        <IconSpeed @click="showSpeed()"></IconSpeed>
        <div id="speed" class="speed">
          <div
            @click="changeSpeed(item.value)"
            class="contSpeedText"
            :class="{ active: speed == item.value }"
            v-for="(item, index) in playSpeed"
            :key="index + '-speed-' + item.value"
          >
            <span class="textSpeed">{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="contIconMid">
        <div class="contIcon">
          <IconPrevious @click="previousCall()"></IconPrevious>
        </div>
        <div @click="skip(-15)" class="contIcon">
          <IconBack></IconBack>
          <span class="centerInIcon">15</span>
        </div>
        <div class="contPlay">
          <IconPlay v-if="play" @click="playMedia()"></IconPlay>
          <IconPause v-else @click="pauseMedia()"></IconPause>
        </div>
        <div @click="skip(15)" class="contIcon">
          <IconSkip></IconSkip>
          <span class="centerInIcon">15</span>
        </div>
        <div class="contIcon">
          <IconNext @click="nextCall()"></IconNext>
        </div>
      </div>
      <div class="contRelative">
        <IconDownload @click="showDownload()"></IconDownload>
        <div id="downloadAudio">
          <div @click="audioDownload('wav')" class="contDownload">
            <span class="textDownload">WAV</span>
          </div>
          <div @click="audioDownload('mp3')" class="contDownload">
            <span class="textDownload">MP3</span>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </v-dialog>
</template>
<script>
import { httpByCurrentCustomer, downloadFromBlob } from "../../lib/client";
import { DateTime } from "luxon";
import WaveSurfer from "wavesurfer.js";
import { mapGetters } from "vuex";
//Icons
import IconClose from "@/assets/iconsMedia/close.svg";
import IconSpeed from "@/assets/iconsMedia/speed.svg";
import IconPlay from "@/assets/iconsMedia/play.svg";
import IconBack from "@/assets/iconsMedia/back.svg";
import IconSkip from "@/assets/iconsMedia/skip.svg";
import IconDownload from "@/assets/iconsMedia/download.svg";
import IconPrevious from "@/assets/iconsMedia/previous.svg";
import IconNext from "@/assets/iconsMedia/next.svg";
import IconSound from "@/assets/iconsMedia/sound.svg";
import IconMute from "@/assets/iconsMedia/mute.svg";
import IconPause from "@/assets/iconsMedia/pause.svg";
let wavesurfer;
export default {
  name: "mediaWaveSurfer",
  props: ["show", "call"],
  components: {
    IconClose,
    IconSpeed,
    IconPlay,
    IconBack,
    IconSkip,
    IconDownload,
    IconPrevious,
    IconNext,
    IconSound,
    IconMute,
    IconPause,
  },
  data() {
    return {
      speed: 1,
      playSpeed: [
        { text: "0.25x", value: 0.25 },
        { text: "0.5x", value: 0.5 },
        { text: "0.75x", value: 0.75 },
        { text: "Normal", value: 1 },
        { text: "1.25x", value: 1.25 },
        { text: "1.5x", value: 1.5 },
        { text: "1.75x", value: 1.75 },
        { text: "2x", value: 2 },
      ],
      loading: true,
      timeF: "00:00:00",
      time2: "00:00:00",
      time3: "00:00:00",
      volR: 10,
      volL: 10,
      showVol1: false,
      showVol2: false,
      showAll: false,
      play: true,
      selectNewTag: "",
      showError: false,
      textError: "",
    };
  },
  mounted() {
    this.createMedia();
    this.getRecUrl();
  },
  beforeUnmount() {
    this.destroyMedia();
  },
  computed: {
    ...mapGetters("tagConfigComments", { tagComments: "listTagComments" }),
    tagLimit() {
      if (this.call.tags.length > 4) {
        return Array.isArray(this.call.tags) ? this.call.tags.slice(0, 4) : [];
      } else {
        return this.call.tags;
      }
    },
  },
  methods: {
    closeDialog() {
      this.destroyMedia();
      this.$emit("closeDialog", false);
    },
    async getRecUrl() {
      const urlBase = `calls/${this.call.id}/audio`;
      try {
        const blobRecording = await httpByCurrentCustomer().get(urlBase).blob();
        wavesurfer.loadBlob(blobRecording);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.textError = "No fue posible cargar el audio.";
        this.showError = true;
      }
    },
    playMedia() {
      this.play = false;
      wavesurfer.play();
    },
    pauseMedia() {
      this.play = true;
      wavesurfer.pause();
    },
    changeSpeed(rate) {
      this.speed = rate;
      wavesurfer.setPlaybackRate(rate);
      const element = document.getElementById("speed");
      element.classList.toggle("show");
    },
    skip(sec) {
      wavesurfer.skip(sec);
    },
    showSpeed() {
      const element = document.getElementById("speed");
      element.classList.toggle("show");
    },
    showDownload() {
      const element = document.getElementById("downloadAudio");
      element.classList.toggle("show");
    },
    audioDownload(format) {
      const downloadCallId = this.call.id;
      const urlBase = `calls/${downloadCallId}/audio`;
      this.isDownloadingAudio = true;
      this.$store.dispatch("updateAudioDownloadStatus", {
        id: downloadCallId,
        status: true,
      });
      httpByCurrentCustomer()
        .get(urlBase + (format == "wav" ? "?format=wav" : ""))
        .blob()
        .then((res) => {
          downloadFromBlob(
            res,
            `${DateTime.fromISO(this.call.callTime).toFormat("yyyyMMddhm")}_${
              this.call.phone
            }.${format}`
          );
          this.$store.dispatch("updateAudioDownloadStatus", {
            id: downloadCallId,
            status: false,
          });
        })
        .catch(() => {
          this.$store.dispatch("updateAudioDownloadStatus", {
            id: downloadCallId,
            status: false,
          });
          this.textError = "No fue posible descargar el audio.";
          this.showError = true;
        });
      const element = document.getElementById("downloadAudio");
      element.classList.toggle("show");
    },
    formatDate(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
      const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
      const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
      const time = new Intl.DateTimeFormat("en", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      }).format(d);
      return `${da} ${mo} ${ye} ${time}`;
    },
    nextCall() {
      this.$emit("nextCall", true);
    },
    previousCall() {
      this.$emit("previousCall", true);
    },
    createMedia() {
      wavesurfer = WaveSurfer.create({
        container: "#wave",
        splitChannels: true,
        barWidth: 2,
        barHeight: 1,
        barRadius: 1,
        barGap: null,
        height: 70,
        normalize: true,
        waveColor: "#1565c0a8",
        progressColor: "#1565C0",
      });
      wavesurfer.on("ready", () => {
        const duration = wavesurfer.getDuration();
        this.timeF = this.getTimeFormat(duration);
        this.time3 = this.getTimeFormat(duration / 1.5);
        this.time2 = this.getTimeFormat(duration / 3);
      });
    },
    destroyMedia() {
      if (wavesurfer) {
        wavesurfer.destroy();
      }
      this.time2 = "00:00:00";
      this.time3 = "00:00:00";
      this.timeF = "00:00:00";
      this.play = true;
      this.loading = true;
    },
    getTimeFormat(duration) {
      const hour = Math.floor(duration / 3600)
        .toString()
        .padStart(2, "0");
      const mins = Math.floor((duration - hour * 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (duration - hour * 3600 - mins * 60)
        .toFixed(0)
        .toString()
        .padStart(2, "0");
      return hour + ":" + mins + ":" + seconds;
    },
    setNewTag() {
      const json = [...this.call.tags];
      if (json.indexOf(this.selectNewTag) < 0) {
        json.push(this.selectNewTag);
        this.requestSetTagCall(json);
      }
    },
    removeTag(tag) {
      const json = [...this.call.tags];
      const idx = json.indexOf(tag);
      json.splice(idx, 1);
      this.requestSetTagCall(json);
    },
    async requestSetTagCall(json) {
      try {
        await httpByCurrentCustomer()
          .put(`calls/${this.call.id}/tags`, { json })
          .then(() => {
            this.selectNewTag = null;
            const callTag = this.call;
            callTag.tags = json;
            this.$store.commit("SET_CALL", callTag);
          });
      } catch {
        this.selectNewTag = null;
        this.textError = "Ha ocurrido un error, por favor inténtelo de nuevo.";
        this.showError = true;
      }
    },
  },
  watch: {
    volL() {
      const splitter = wavesurfer.backend.ac.createChannelSplitter(2);
      const merger = wavesurfer.backend.ac.createChannelMerger(2);
      const leftGain = wavesurfer.backend.ac.createGain();
      const rightGain = wavesurfer.backend.ac.createGain();
      splitter.connect(leftGain, 0);
      splitter.connect(rightGain, 1);
      leftGain.connect(merger, 0, 0);
      rightGain.connect(merger, 0, 1);
      wavesurfer.backend.setFilters([splitter, leftGain, merger]);
      leftGain.gain.value = this.volL / 10;
      rightGain.gain.value = this.volR / 10;
    },
    volR() {
      const splitter = wavesurfer.backend.ac.createChannelSplitter(2);
      const merger = wavesurfer.backend.ac.createChannelMerger(2);
      const leftGain = wavesurfer.backend.ac.createGain();
      const rightGain = wavesurfer.backend.ac.createGain();
      splitter.connect(leftGain, 0);
      splitter.connect(rightGain, 1);
      leftGain.connect(merger, 0, 0);
      rightGain.connect(merger, 0, 1);
      wavesurfer.backend.setFilters([splitter, leftGain, merger]);
      leftGain.gain.value = this.volL / 10;
      rightGain.gain.value = this.volR / 10;
    },
    call() {
      this.destroyMedia();
      this.createMedia();
      this.getRecUrl();
    },
  },
};
</script>
<style lang="scss">
.v-dialog {
  &.dialogMedia {
    background: #ffffff;
    max-width: 700px;
    position: relative;
    border-radius: 18px;
    padding: 10px 0 0 0;
    .close {
      position: absolute;
      top: 15px;
      right: 20px;
      cursor: pointer;
      width: 16px;
      height: 15px;
    }
    .titleAudio {
      font-size: 14px;

      font-weight: bold;
      margin: 0 0 10px 0;
      padding: 0 40px 0 15px;
    }
    .icon-mks {
      &.icon_close {
        position: absolute;
        top: 10px;
        right: 18px;
        cursor: pointer;
      }
    }
    .contFooter {
      width: 100%;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px 4px 12px;
      background: #fafafa;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        height: 1px;
        width: 95%;
        border-top: 1px solid #6879801c;
      }
      .icon-mks {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
      svg {
        cursor: pointer;
        user-select: none;
      }
    }
    .contIconMid {
      display: flex;
      display: flex;
      width: 100%;
      max-width: 220px;
      justify-content: space-between;
      margin: 0 10px;
    }
    .contPlay {
      display: flex;
      align-items: center;
    }
    .contIcon {
      position: relative;
      display: flex;
      align-items: center;
      .centerInIcon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 11px;
        font-weight: 100;
        font-family: sans-serif;
        color: #424242;
        cursor: pointer;
        user-select: none;
      }
    }
    .contRelative {
      position: relative;
      .speed {
        visibility: hidden;
        position: absolute;
        top: -205px;
        right: -55px;
        background: #ffffff;
        z-index: 4;
        box-shadow: 1px 1px 10px rgb(0 0 0 / 10%);
        border-radius: 7px;
        padding: 5px 0px;
        min-width: 80px;
        .contSpeedText {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 3px 0;
          cursor: pointer;
          &.active {
            background: #f2f3f5;
          }
        }
        .textSpeed {
          font-size: 12px;
          color: #424242;
          font-weight: 300;
          cursor: pointer;
          user-select: none;
        }
        &.show {
          visibility: visible;
        }
      }
      #downloadAudio {
        visibility: hidden;
        position: absolute;
        top: -16px;
        right: 39px;
        background: #ffffff;
        z-index: 4;
        box-shadow: 1px 1px 10px rgb(0 0 0 / 10%);
        border-radius: 7px;
        padding: 2px 10px;
        min-width: 70px;
        &.show {
          visibility: visible;
        }
        .textDownload {
          font-size: 12px;
          color: #424242;
          font-weight: 300;
          cursor: pointer;
          user-select: none;
          &.disabled {
            color: #42424229;
            cursor: not-allowed;
          }
        }
        .contDownload {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2px 0;
        }
      }
    }
    .contTime {
      display: flex;
      justify-content: space-between;
      padding: 6px 50px 10px 15px;
      .textTime {
        font-size: 14px;
        font-weight: 400;
        user-select: none;
      }
    }
    .contPrefix {
      display: flex;
      gap: 5px 5px;
      width: 100%;
      flex-wrap: wrap;
      .prefix {
        border: 1px solid #1565c0;
        padding: 0px 10px;
        border-radius: 20px;
        .textPrefix {
          color: #1565c0;
          font-size: 12px;
          white-space: nowrap;
        }
      }
      .textMore {
        color: #1565c0;
        font-size: 12px;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    #wave {
      width: 100%;
      margin: 0 35px 0 0;
    }
    .contWavesurfer {
      display: flex;
      position: relative;
      padding: 0 15px;
    }
    #volControl1 {
      display: none;
      &.show {
        visibility: visible;
      }
      &:hover {
        display: flex !important;
      }
    }
    .contVol {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      position: absolute;
      right: 15px;
      width: 35px;
      svg {
        cursor: pointer;
        user-select: none;
      }
      .vol {
        position: relative;
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          #volControl1 {
            display: flex !important;
          }
        }
      }
      .volControl {
        position: absolute;
        width: 100px;
        top: 3px;
        left: -92px;
        background: #eeeeee;
        z-index: 3;
        max-height: 28px;
        border-radius: 20px;
        padding: 0 7px;
        .v-slider--horizontal {
          min-height: 30px;
        }
      }
    }
    .contLoading {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100px;
    }
    .contTagSelect {
      border-top: thin solid rgba(0, 0, 0, 0.12);
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
      margin: 5px 15px;
      padding: 5px 0;
      width: calc(100% - 30px);
    }
    .v-input {
      &.customInpuntMedia {
        max-width: 300px;
        .v-input__control {
          min-height: 26px;
          .v-input__slot {
            box-shadow: none;
            border: 1px solid #1565c0;
            .v-select__selections {
              input {
                padding: 1px 0 1px;
                font-size: 12px;
              }
            }
            .v-select__selection--comma {
              margin: 1px 4px 1px 0;
            }
          }
        }
        .v-text-field__details {
          margin-bottom: 0px;
          min-height: 0px;
          height: 0px;
        }
      }
    }
  }
}
</style>
